/** @format */

import { CookieService, UtilityService } from '@shared/utils/services';

import { CheckoutFlow } from '@shared/data-access/enums';
import { Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root'
})
export class ModernCheckoutCartEvaluatorService {
	private _modernCheckoutEnabled = false;

	get modernCheckoutEnabled(): boolean {
		return this._modernCheckoutEnabled;
	}

	set modernCheckoutEnabled(value: boolean) {
		this._modernCheckoutEnabled = value;
	}

	private _checkoutKey: string;

	get checkoutKey(): string {
		return this._checkoutKey;
	}

	set checkoutKey(value: string) {
		this._checkoutKey = value;
	}

	constructor(
		private utilityService: UtilityService,
		private cookieService: CookieService
	) {}

	/**
	 * @description
	 * Evaluates a cookie and determines which checkout flow to evaluate to
	 * and returns an enum for which flow to use
	 */
	evaluateCookie(modernCheckoutCookie = Boolean(this.cookieService.get('modern'))): CheckoutFlow {
		if (modernCheckoutCookie) {
			return CheckoutFlow.MODERN;
		}

		if (!this.modernCheckoutEnabled) {
			return CheckoutFlow.LEGACY;
		}

		return CheckoutFlow.MODERN;
	}

	deleteCheckoutCookieIfInvalid(modernCheckoutCookie: boolean): boolean {
		if (
			modernCheckoutCookie &&
			this.modernCheckoutEnabled &&
			this.evaluateCookie(modernCheckoutCookie) === CheckoutFlow.MODERN &&
			this.utilityService.isValidUUID(this.checkoutKey)
		) {
			this.checkoutKey = '';
			this.cookieService.delete('X-DCSG-CHECKOUT', '/', null);
			return true;
		}

		return false;
	}
}
